"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "small"],
    _excluded2 = ["children", "className"],
    _excluded3 = ["children", "className"],
    _excluded4 = ["children", "className"],
    _excluded5 = ["className", "spritemap", "symbol"],
    _excluded6 = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Group = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      small = _ref.small,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-group', {
      'form-group-sm': small
    }, className),
    ref: ref
  }), children);
});

Group.displayName = 'ClayFormGroup';

var Text = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-text', className),
    ref: ref
  }), children);
});

Text.displayName = 'ClayFormText';

var FeedbackGroup = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      className = _ref3.className,
      otherProps = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-feedback-group', className),
    ref: ref
  }), children);
});

FeedbackGroup.displayName = 'ClayFormFeedbackGroup';

var FeedbackItem = /*#__PURE__*/_react.default.forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
      className = _ref4.className,
      otherProps = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-feedback-item', className),
    ref: ref
  }), children);
});

FeedbackItem.displayName = 'ClayFormFeedbackItem';

var FeedbackIndicator = /*#__PURE__*/_react.default.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
      spritemap = _ref5.spritemap,
      symbol = _ref5.symbol,
      otherProps = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-feedback-indicator', 'inline-item-before', className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: symbol
  }));
});

FeedbackIndicator.displayName = 'ClayFormFeedbackIndicator';

var ClayForm = /*#__PURE__*/_react.default.forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
      otherProps = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_react.default.createElement("form", _extends({}, otherProps, {
    ref: ref
  }), children);
});

ClayForm.displayName = 'ClayForm';

var _default = Object.assign(ClayForm, {
  FeedbackGroup: FeedbackGroup,
  FeedbackIndicator: FeedbackIndicator,
  FeedbackItem: FeedbackItem,
  Group: Group,
  Text: Text
});

exports.default = _default;